import { render, staticRenderFns } from "./PaymentResponse.vue?vue&type=template&id=2d714980"
import script from "./PaymentResponse.vue?vue&type=script&lang=js"
export * from "./PaymentResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports